import { defineStore } from 'pinia';
import { ref } from 'vue';
import { SettingsTabId } from '@/apps/admin/components/settings/constants';

export const useSettingsStore = defineStore('jobBoardSettings', () => {
   const activeTab = ref<SettingsTabId>(SettingsTabId.General);
   const validationErrors = ref<Record<string, any>>({});

   function setActiveTab(tabId: SettingsTabId) {
      activeTab.value = tabId;
   }

   function resetValidationErrors() {
      validationErrors.value = {};
   }

   function setValidationErrors(errors: Record<string, any>) {
      validationErrors.value = errors;
   }

   return {
      activeTab,
      setActiveTab,
      validationErrors,
      resetValidationErrors,
      setValidationErrors,
   };
});
